<template>
<div>

  <div class="Creds" v-if="able">
<lk-select v-model="type" @on-change="handleType" clearable transfer>
  <lk-option v-for="(item,i) in types" :key="item" :value="i*1">{{item}}</lk-option>
</lk-select>
<lk-input v-model="value" @on-change="handleInput" @on-blur="handleBlur" :placeholder='placeholder'></lk-input>
  </div>

  <span v-else>
    {{str}}
  </span>
</div>
</template>

<script>
// import utils from '../../libs/utils';

export default {
  name: 'CredentialsInput',
  props: {
    able: {
      default: true,
      // required: true,
    },
    infos: {
      required: true,
      type: Object,
    },
    codeKey: {
      default: 'patientIdCard',
    },
    typeKey: {
      default: 'permissionType',
    },
    placeholder: {
      type: String,
    }
  },

  model: {
    event: 'on-change',
    prop: 'infos',
  },
  computed: {
    str() {
      return this.types[this.type] ? this.types[this.type] + this.value : `${this.value}`;
    },
    types() {
      return this.$store.state.publicParams.credentialsTypes;
    },
  },
  data() {
    return {
      value: '',
      type: null,

      // validators: {
      //   1:
      // },
    };
  },
  methods: {
    handleBlur() {
      this.emitValue();
      this.dispatch('FormItem', 'on-form-blur', this.value);
    },
    emitValue() {
      console.log(1);
      const res = this.infos;
      res[this.codeKey] = this.value;
      res[this.typeKey] = this.type;

      this.$emit('on-change', res);
      this.dispatch('FormItem', 'on-form-change', this.value);
    },
    handleInput() {
      this.emitValue();
      // this.dispatch('FormItem', 'on-form-change', this.value);
    },
    handleType() {
      this.$emit('setRules', this.type);
      this.emitValue();
      // this.dispatch('FormItem', 'on-form-change', this.value);
      this.dispatch('FormItem', 'on-form-blur', this.value);
    },
    dispatch(componentName, eventName, params) {
      let parent = this.$parent || this.$root;
      let name = parent.$options.name;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.name;
        }
      }
      if (parent) {
        parent.$emit(...[eventName].concat(params));
      }
    },
  },
  mounted() {
    this.value = this.infos[this.codeKey];
    this.type = this.infos[this.typeKey];

    this.$watch(`infos.${this.codeKey}`, (val) => {
      this.value = val;
    });
    this.$watch(`infos.${this.typeKey}`, (val) => {
      this.type = val;
      this.$emit('setRules', this.type);
    });
  },
};
</script>

<style lang="less" scoped>
.Creds{
  width: 100%;
  display: flex;
  flex-shrink: 0;
  >:first-child{
    width: 30%
  }
  >:nth-child(2){
    width: 70%
  }
}
</style>
